// extracted by mini-css-extract-plugin
export default {"buttonContainer":"kAhcT","alignToEdge":"Jqq-E","buttonIcon":"_52lP3","buttonCaption":"fGKT0","buttonSpacer":"_1XqI9"};